import { Text, type TextStyle } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  const boldFontWeight = String(theme.fontWeightBold) as TextStyle['fontWeight']

  return {
    base: {
      fontFamily: 'RDModern-SemiBold',
      fontWeight: boldFontWeight,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      paddingRight: theme.paddingInsetTwopulse,
      backgroundColor: 'transparent',
      color: theme.colorTextNeutralAlternative,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
    },
    variants: {
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    },
  }
})
